<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-12', 'col-md-12', 'col-12']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-3']">ACCESO A LA INFORMACIÓN</h3>
                                <hr :class="['mt-1', 'mb-3']">
                                <p>
                                    Aquí podrás realizar tus pedidos de acceso a la información pública, también encontrarás el formato de solicitud si prefieres presentarlo en físico.
                                </p>

                                <div :class="['row', '']">
                                    <div :class="['col-lg-12', '']">
                                        <button :disabled="file_select=='VISTA_PREVIA_WEB.pdf'" @click="downloadItem(path_file_download, file_select)" :class="['btn', 'btn-success', 'mb-4', 'btn-block']">
                                            <i :class="['fa', 'fa-download', 'ml-2']" aria-hidden="true"></i>
                                            Descargar
                                            <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>

                                <div :class="['row']">
                                    <div :class="['col-lg-12', 'mt-4']">
                                        <div class="table-responsive">
                                            <PdfThumbnail :fileUrl="url_prev" :updateFile="url_prev" style="border:2px solid #dee2e6; border-radius:5px;" :target="'_blank'" :width="1050"></PdfThumbnail>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import PdfThumbnail from '@/components/PdfThumbnail.vue';
    import Grid from  '@/layout/Grid.vue';
    export default {
        name: 'Precios_productos',
        components:{
            Grid,
            PdfThumbnail,
        },
        computed:{
            ...mapState(['loading','globales','empresa']),
            url_prev(){
                this.path_file_download = `${window.baseUrl}webserviceserver/fileCors?file=${this.file_select}&dir=organigrama`;
                return this.path_file_download;
            },
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Organigrama || "+((this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM");
        },
        data(){
            return{
                file_select:"ORGANIGRAMA_DRASAM_2019.pdf",
                path_file_select:"",
                path_file_download:"",
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
        },
    }
</script>